import { Box, Switch, Typography, styled, Link as MuiLink } from '@mui/material';
import { COLOR_ORANGE_PRIMARY, COLOR_TEXT, COLOR_SECONDARY, COLOR_LIGHTGRAY } from '../../constants/color';
import { SecondaryButton } from './SecondaryButton';
import oneClickApplySvg from '../../assets/images/oneClickApplySvg.svg';
import savedIcon from '../../assets/images/dashboard/savedIcon.svg';
import unSavedIcon from '../../assets/images/dashboard/unsavedIcon.svg';
import { useEffect, useState } from 'react';
import winSwitch from '../../assets/images/dashboard/SwitchWin.svg';
import AwardedBadge from '../../assets/images/ScholarshipPage/AwardedBadge.svg';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import LockIcon from '@mui/icons-material/Lock';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';


interface IDashboardCard {
    showRemoveBtn?: boolean;
    showAddBtn?: boolean;
    showCompetition?: boolean;
    showDeadline?: boolean;
    showCreatedAt?: boolean;
    usedTab?: string;
    item: {};
    styleProps?: {};
    brandingBgColor?: string;
    brandingTextColor?: string;
    selectedRowsToDelete?: any;
    responsedata?: any;
    applyApplyableScholarship?: (scholarshipId: number) => void;
    applyNonApplyableScholarship?: (scholarshipId: number, sholarshipUrl: string) => void;
    viewCompletedScholarship?: (scholarshipId: number, applicationStatus: string) => void;
    viewNotCompletedScholarship?: (scholarshipId: number, applicationStatus: string) => void;
    viewNonApplyableScholarship?: (scholarshipUrl: string) => void;
    viewAwardedScholarship?: (scholarshipUrl: string) => void;
    handleOnSaved?: (scholarshipId: number, isSaved: string) => void;
    viewScholarShipCounselor?: (scholarshipId: number, applicationData: any) => void;
    viewOrganizationScholarship?: (organizationId: number) => void;
    addScholarshipList?: (organizationId: number) => void;
    removeOrganization?: (organizationId: number) => void;
    handleRemoveScholarship?: (scholarshipId: number) => void;
    handleToggleWin?: (scholarship: any) => void;
    handleViewEmbeddedScholarship?: (scholarshipId: number) => void;
    handleDeleteAwardedScholarship?: (checked: boolean, scholarshipId: number) => void;
    handleDeleteAppliedScholarship?: (checked: boolean, scholarshipId: number) => void;
    handleScholarhipFeaturedOrUnfeaturedChange?: (isFeatured: boolean, scholarshipId: number) => void;
    openSummaryModal?: (item: {}) => void;
    deleteAdminScholarship?: (id: number) => void;
    ViewScholarshipInfo?: (rowIndex: number) => void;
    isLandingPage?: boolean;
}

export default function DashboardSchoarshipCard({
    showAddBtn = false,
    showRemoveBtn = false,
    showDeadline = true,
    showCompetition = true,
    showCreatedAt = false,
    usedTab,
    item,
    styleProps,
    brandingBgColor,
    brandingTextColor,
    selectedRowsToDelete,
    responsedata,
    applyApplyableScholarship,
    applyNonApplyableScholarship,
    viewCompletedScholarship,
    viewNotCompletedScholarship,
    viewNonApplyableScholarship,
    viewAwardedScholarship,
    handleOnSaved,
    handleToggleWin,
    viewScholarShipCounselor,
    viewOrganizationScholarship,
    addScholarshipList,
    removeOrganization,
    handleRemoveScholarship,
    handleViewEmbeddedScholarship,
    handleDeleteAwardedScholarship,
    handleDeleteAppliedScholarship,
    openSummaryModal,
    deleteAdminScholarship,
    ViewScholarshipInfo,
    handleScholarhipFeaturedOrUnfeaturedChange
}: IDashboardCard) {
    console.log(item);

    const loginDataFromRedux = useSelector((state) => state.login);
    const auth_token = loginDataFromRedux?.loginDetails?.data?.auth_token;
    const { isAuth } = loginDataFromRedux;
    const userRole = loginDataFromRedux?.loginDetails?.data?.user?.usersRoles?.[0]?.role?.normalizedName;

    const [checked, setChecked] = useState(false);
    const handleSelect = (checked: boolean, scholarshipId: number) => {
        setChecked(checked);
        handleDeleteAppliedScholarship && handleDeleteAppliedScholarship(checked, scholarshipId);
        handleDeleteAwardedScholarship && handleDeleteAwardedScholarship(checked, scholarshipId);
    };

    useEffect(() => {
        selectedRowsToDelete?.includes(item?.id) ? setChecked(true) : setChecked(false);
    }, [selectedRowsToDelete?.length]);

    const ScholarShipCard = styled(Box)(({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'space-between',
        height: '100%',
        width: '48%',
        borderRadius: '10px',
        background: '#FFF',
        padding: '16px',
        /* new drop shadow */
        boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.20)',
        ...styleProps,
        zIndex:1,
        transition: 'all 0.3s ease-in-out',
                                        transform: 'scale(1)',
        [theme.breakpoints.down('sm')]: {
            width: '100%',

        },
        '&:hover': {
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
            background: 'rgba(247,148,29, 0.1)'
        }
    }));

    const ScholarShipMoreDetailsChip = styled(Box)(({ theme }) => ({
        fontFamily: 'Poppins',
        fontSize: '8px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '12px',
        backgroundColor: brandingBgColor ? brandingBgColor : COLOR_ORANGE_PRIMARY,
        padding: '4px 7px',
        width: 'fit-content',
        borderRadius: '3.5px',
        color: '#fff',
        cursor: 'pointer',
    }));
    const ScholarShipReqChip = styled(Box)(({ theme }) => ({
        fontFamily: 'Poppins',
        fontSize: '8px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '12px',
        padding: '4px 7px',
        width: 'fit-content',
        borderRadius: '3.5px',
        color: '#545D69',
        background: '#ECECEC',
    }));

    const ScholarShipReqChipContainer = styled(Box)(({ theme }) => ({
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        position: 'relative',
    }));

    const ScholarShipCardHeader = styled(Typography)(({ theme }) => ({
        color: '#000',
        textAlign: 'left',
        wordBreak: 'break-word',
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: 'normal',
        margin: '0px 0 12px 0',
        [theme.breakpoints.down('md')]: {
            fontSize: '14px',
        },
        '&:hover': {
            color: COLOR_ORANGE_PRIMARY,
            cursor: 'pointer',
        }
    }));

    const ScholarShipCardDescription = styled(Typography)(({ theme }) => ({
        color: '#000',
        textAlign: 'left',
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
        margin: '4px 0 12px 0',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
        },
    }));

    const ScholarShipCardDeadlineText = styled(Typography)(({ theme }) => ({
        color: '#000',
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: 'normal',
        [theme.breakpoints.down('md')]: {
            fontSize: '12px',
        },
    }));

    const ScholarShipCardDeadlineContent = styled(Typography)(({ theme }) => ({
        color: brandingBgColor ? brandingBgColor : COLOR_ORANGE_PRIMARY,

        fontFamily: 'Poppins',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: 'normal',
    }));

    const ScholarShipCardAmount = styled(Typography)(({ theme }) => ({
        color: brandingBgColor ? brandingBgColor : COLOR_ORANGE_PRIMARY,
        fontFamily: 'Poppins',
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
        [theme.breakpoints.down('md')]: {
            fontSize: '18px',
        },
    }));

    const ScholarShipCardAmountModified = styled(Typography)(({ theme }) => ({
        color: COLOR_ORANGE_PRIMARY,

        fontFamily: 'Poppins',
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
        marginRight: '8px',
        [theme.breakpoints.down('md')]: {
            fontSize: '14px',
        },
    }));

    const ScholarShipCardOneClickText = styled(Typography)(({ theme }) => ({
        color: '#545D69',
        fontFamily: 'Source Sans Pro',
        fontSize: '10px',
        fontStyle: 'italic',
        fontWeight: 400,
        lineHeight: 'norm18pxal',
        marginLeft: '4px',
    }));

    const ScholarShipCardPopUpheader = styled(Typography)(({ theme }) => ({
        color: '#000',
        fontFamily: 'poppins',
        fontSize: '10px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '125%',
        borderBottom: '1px solid #D9D9D9',
        paddingBottom: '4px',
    }));

    const ScholarShipCardPopUpContent = styled(Typography)(({ theme }) => ({
        color: '#838383',
        fontFamily: 'poppins',
        fontSize: '10px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '125%',
        marginTop: '4px',
    }));

    const DidyouWinText = styled(Typography)(({ theme }) => ({
        color: '#838383',
        fontFamily: 'poppins',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '125%',
        marginRight: '8px',
        whiteSpace: 'nowrap',
    }));

    const ResumeText = styled(Typography)(({ theme }) => ({
        color: '#000',
        fontFamily: 'poppins',
        fontSize: '6px',
        fontStyle: 'normal',
        fontWeight: 300,
        lineHeight: '125%',
        whiteSpace: 'nowrap',
        textAlign: 'center',
    }));

    const handleScholarshipApply = (isApplyable: boolean, scholarshipDetails: any) => {
        if (isApplyable) {
            applyApplyableScholarship && applyApplyableScholarship(scholarshipDetails?.id);
        } else {
            applyNonApplyableScholarship &&
                applyNonApplyableScholarship(scholarshipDetails?.id, scholarshipDetails?.url);
        }
    };

    const handleScholarshipViewResume = (
        isApplyable: boolean,
        applicationStatus: string,
        scholarshipUrl: string,
        scholarshipId: number
    ) => {
        if (isApplyable) {
            if (applicationStatus === 'complete') {
                viewCompletedScholarship && viewCompletedScholarship(scholarshipId, applicationStatus);
            } else {
                viewNotCompletedScholarship && viewNotCompletedScholarship(scholarshipId, applicationStatus);
            }
        } else {
            viewNonApplyableScholarship && viewNonApplyableScholarship(scholarshipUrl);
        }
    };
    const currentDate = new Date();
    const deadlineDate = new Date(item?.deadline);
    const formatDate = (dateString) => {
        if (!dateString) return 'not selected'; // Handle the case where the deadline is not provided

        const date = new Date(dateString);
        const year = date.getFullYear().toString(); // Get the last two digits of the year
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add leading zero if needed
        const day = date.getDate().toString().padStart(2, '0'); // Add leading zero if needed

        return `${month}/${day}/${year}`;
    };

    const isExpired = currentDate > deadlineDate;
    const sId = item?.data?.id;
    const status = item?.data?.status;

    const [moreDetailsPopUp, setMoreDetailsPopup] = useState(null);

    const scholarshipId = item?.scholarshipId;
    const name = `${item?.name ? item?.name : item?.title}`;
    const titleInLowerCase = name.toLowerCase();
    const dashedScholarshipName = titleInLowerCase.replace(/[,./?]|\s+/g, (match) => match === ',' || match === '.' || match === '?' || match === '/' ? '' : '-');

    return (

        <Link to={`/scholarships/${dashedScholarshipName}/${scholarshipId}`} style={{ textDecoration: 'none', display: 'flex', height: '100%', width: '100%', justifyContent: 'center', zIndex:1 }}>
            <ScholarShipCard>

                <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                    <Box display="flex" alignItems="center" gap="4px">
                        {usedTab === 'awarded' && (
                            <Box display="flex" alignItems="center">
                                <img src={AwardedBadge} alt="apply button" width="16px" height="16px" />
                                <ScholarShipCardOneClickText>AWARDED</ScholarShipCardOneClickText>
                            </Box>
                        )}
                        {item?.applyable && (
                            <Box display="flex" alignItems="center">
                                <img src={oneClickApplySvg} alt="apply button" width="16px" height="16px" />
                                <ScholarShipCardOneClickText>ONE CLICK APPLY</ScholarShipCardOneClickText>
                            </Box>
                        )}
                        {currentDate > deadlineDate && (usedTab === 'awarded' || usedTab === 'applied') && (
                            <Box display="flex" alignItems="center" gap="4px">
                                <span style={{ color: '#F7941D' }}>
                                    <LockIcon sx={{ width: '14px', height: '14px' }} />
                                </span>
                                <span className="one-click-apply-text">CLOSED</span>
                            </Box>
                        )}
                    </Box>

                    {usedTab === 'awarded' && showRemoveBtn && (
                        <Box>
                            {checked || selectedRowsToDelete?.includes(item?.id) ? (
                                <CheckBoxIcon
                                    sx={{ color: COLOR_ORANGE_PRIMARY, cursor: 'pointer' }}
                                    onClick={() => handleSelect(false, item?.id)}
                                />
                            ) : (
                                <CheckBoxOutlineBlankIcon
                                    sx={{ color: COLOR_ORANGE_PRIMARY, cursor: 'pointer' }}
                                    onClick={() => handleSelect(true, item?.id)}
                                />
                            )}
                        </Box>
                    )}

                    {usedTab === 'applied' && showRemoveBtn && (
                        <Box>
                            {checked ? (
                                <CheckBoxIcon
                                    sx={{ color: COLOR_ORANGE_PRIMARY, cursor: 'pointer' }}
                                    onClick={() => handleSelect(false, item?.id)}
                                />
                            ) : (
                                <CheckBoxOutlineBlankIcon
                                    sx={{ color: COLOR_ORANGE_PRIMARY, cursor: 'pointer' }}
                                    onClick={() => handleSelect(true, item?.id)}
                                />
                            )}
                        </Box>
                    )}
                    {(usedTab === 'saved' || usedTab === 'find') && (
                        <Box ml="auto" display="flex" alignItems="center">
                            {item?.data?.status === 'Saved' ? (
                                <img
                                    src={savedIcon}
                                    alt="savedIcon"
                                    onClick={() => {
                                        handleOnSaved && handleOnSaved(sId, status);
                                    }}
                                />
                            ) : (
                                <img
                                    src={unSavedIcon}
                                    alt="unSavedIcon"
                                    onClick={() => {
                                        handleOnSaved && handleOnSaved(sId, status);
                                    }}
                                />
                            )}
                        </Box>
                    )}
                    {usedTab === 'scholarship-admin' && (
                        <Box ml="auto" display="flex" alignItems="center">
                        {(item?.isfeature || item?.isFeature) ? (
                            <StarIcon
                            sx={{ color: COLOR_ORANGE_PRIMARY , zIndex:99999}} 
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleScholarhipFeaturedOrUnfeaturedChange && handleScholarhipFeaturedOrUnfeaturedChange(item?.isfeature || item?.isFeature, item?.id);
                                }}
                            />
                        ) : (
                            <StarBorderIcon
                            sx={{ color: COLOR_TEXT,  zIndex:99999 }} 
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleScholarhipFeaturedOrUnfeaturedChange && handleScholarhipFeaturedOrUnfeaturedChange(item?.isfeature || item?.isFeature, item?.id);
                                }}
                            />
                        )}
                    </Box>
                    )}
                </Box>
                {item?.data?.title && <ScholarShipCardHeader onClick={() => openSummaryModal && openSummaryModal(item)}>{item?.data?.title}</ScholarShipCardHeader>}
                {(usedTab === 'counselor-manage' || usedTab === 'embeddedSholarship' || item?.title) && (
                    <ScholarShipCardHeader >{item?.title}</ScholarShipCardHeader>
                )}
                {(usedTab === 'scholarshipInfo' ||
                    usedTab === 'external-scholarship-admin') && (
                        <ScholarShipCardHeader >{item?.name}</ScholarShipCardHeader>
                    )}

                {usedTab === 'external-scholarship-admin' && (
                    <ScholarShipCardDescription>{item?.description}</ScholarShipCardDescription>
                )}
                {usedTab === 'external-scholarship-admin' && (
                    <>
                        {item?.homeUrl && (
                            <ScholarShipCardDescription sx={{ mb: '0', color: '#838383' }}>
                                <Typography fontWeight="700" fontFamily="poppins" fontSize="12px">
                                    Home Url:
                                </Typography>
                                {item?.homeUrl}
                            </ScholarShipCardDescription>
                        )}

                        {item?.scholarshipUrl && (
                            <ScholarShipCardDescription
                                sx={{
                                    color: '#838383',
                                    wordWrap: 'break-word!important',
                                    whiteSpace: 'wrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',

                                    '@media(max-width: 650px)': {
                                        maxWidth: '200px',
                                    },

                                    '@media(max-width: 600px)': {
                                        maxWidth: '350px',
                                    },
                                    '@media(max-width: 500px)': {
                                        maxWidth: '320px',
                                    },
                                    '@media(max-width: 400px)': {
                                        maxWidth: '300px',
                                    },
                                    '@media(max-width: 375px)': {
                                        maxWidth: '250px',
                                    },
                                    '@media(max-width: 310px)': {
                                        maxWidth: '200px',
                                    },
                                }}>
                                <Typography fontWeight="700" fontFamily="poppins" fontSize="12px" sx={{}}>
                                    Scholarship Url:
                                </Typography>
                                {item?.scholarshipUrl}
                            </ScholarShipCardDescription>
                        )}
                    </>
                )}
                {usedTab === 'counselor-organization' ||
                    (usedTab === 'multiple-scholarship-url' && <ScholarShipCardHeader>{item?.name}</ScholarShipCardHeader>)}
                {item?.requirements && usedTab !== 'landingPage' && (
                    <ScholarShipReqChipContainer sx={{ mb: usedTab === 'counselor-manage' ? 0 : '16px' }}>
                        {(item?.hasMoreQualification || item?.hasMoreRequirement || item?.hasMoreQualifications) && (
                            <ScholarShipMoreDetailsChip
                                onMouseOver={() => setMoreDetailsPopup(item)}
                                onMouseLeave={() => setMoreDetailsPopup(null)}>
                                More details
                            </ScholarShipMoreDetailsChip>
                        )}
                        {item?.requirements?.map((reqItem, index) => (
                            <ScholarShipReqChip>{reqItem?.name}</ScholarShipReqChip>
                        ))}
                        {item?.requiredEthnicities?.map((reqItem, index) => (
                            <ScholarShipReqChip>{reqItem?.title}</ScholarShipReqChip>
                        ))}
                        {item?.requiredGenders?.map((reqItem, index) => (
                            <ScholarShipReqChip>{reqItem?.title}</ScholarShipReqChip>
                        ))}

                        {item?.ageRequirementLowerBound != null && item?.ageRequirementLowerBound !== null && (
                            <ScholarShipReqChip> Age {item?.ageRequirementLowerBound} +</ScholarShipReqChip>
                        )}
                        {item?.gpaRequirementLowerBound != null && item?.gpaRequirementUpperBound !== null && (
                            <ScholarShipReqChip> GPA {item?.gpaRequirementLowerBound} +</ScholarShipReqChip>
                        )}
                        {item?.essayRequirements && <ScholarShipReqChip> Essay</ScholarShipReqChip>}

                        {moreDetailsPopUp?.id === item?.id && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    left: 0,
                                    top: '32px',
                                    background: '#fff',
                                    p: '4px 8px',
                                    border: '1px solid #D9D9D9',
                                    borderRadius: '4px',
                                    maxWidth: '275px',
                                }}>
                                {item?.moreQualification && (
                                    <Box>
                                        <ScholarShipCardPopUpheader>Requirements</ScholarShipCardPopUpheader>
                                        <ScholarShipCardPopUpContent>{item?.moreQualification}</ScholarShipCardPopUpContent>
                                    </Box>
                                )}
                                {item?.moreRequirement && (
                                    <Box>
                                        <ScholarShipCardPopUpheader>Qualification</ScholarShipCardPopUpheader>
                                        <ScholarShipCardPopUpContent>{item?.moreRequirement}</ScholarShipCardPopUpContent>
                                    </Box>
                                )}
                                {!item?.moreRequirement && !item?.moreQualification && (
                                    <ScholarShipCardPopUpheader>No data available</ScholarShipCardPopUpheader>
                                )}
                            </Box>
                        )}
                    </ScholarShipReqChipContainer>
                )}

                {usedTab === 'multiple-scholarship-url' && (
                    <Box display="flex" flexDirection="column" mr="8px">
                        <Box display="flex" alignItems="center">
                            <Box width="5px" height="5px" borderRadius="50%" mr="4px" sx={{ background: '#000' }} />
                            <Typography sx={{ fontSize: '14px', fontWeight: '500', fontFamily: 'poppins' }}>Url</Typography>
                        </Box>

                        <Box textAlign="left">
                            <Box
                                sx={{
                                    width: '90%',
                                    '@media(max-width: 470px)': {
                                        width: '300px',
                                    },
                                    '@media(max-width: 360px)': {
                                        width: '250px',
                                    },
                                    '@media(max-width: 300px)': {
                                        width: '200px',
                                    },
                                }}>
                                <Typography
                                    sx={{
                                        color: COLOR_TEXT,
                                        fontSize: '13px',
                                        fontFamily: 'Poppins',
                                        wordWrap: 'break-word!important',
                                        whiteSpace: 'wrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}>
                                    {item?.url || 'NA'}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                )}

                <Box display="flex" flexWrap="wrap" alignItems="flex-start" justifyContent="flex-start" gap="5px">
                    {(usedTab === 'applied' || usedTab === 'awarded') && (
                        <ScholarShipCardAmountModified>
                            {'$' + item?.amount?.toLocaleString()}
                        </ScholarShipCardAmountModified>
                    )}

                    {/* {usedTab === 'landingPage' && (
                    <Box display="flex" alignItems="center">
                        <Box width="5px" height="5px" mr="12px" borderRadius="50%" sx={{ background: '#000' }} />
                        <Box textAlign="left">
                            <ScholarShipCardDeadlineText>Amount</ScholarShipCardDeadlineText>
                            <ScholarShipCardDeadlineContent>
                                {'$' + item?.amount?.toLocaleString()}
                            </ScholarShipCardDeadlineContent>
                        </Box>
                    </Box>
                )} */}

                    {showDeadline && (
                        <Box display="flex" alignItems="center" mr="8px">
                            <Box width="5px" height="5px" borderRadius="50%" mr="12px" sx={{ background: '#000' }} />

                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>Deadline</ScholarShipCardDeadlineText>
                                {item?.data?.deadline ? (
                                    <ScholarShipCardDeadlineContent>
                                        {formatDate(item?.data?.deadline)}
                                    </ScholarShipCardDeadlineContent>
                                ) : (
                                    <ScholarShipCardDeadlineContent>
                                        {formatDate(item?.deadline)}
                                    </ScholarShipCardDeadlineContent>
                                )}
                                {isExpired && (
                                    <Box mt="4px" id="scholarship-expired-status">
                                        <p id="expired-status-text">
                                            <Box id="expired-img" />
                                            &nbsp;Expired
                                        </p>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    )}

                    {showCreatedAt && (
                        <Box display="flex" alignItems="center" mr="8px">
                            <Box width="5px" height="5px" borderRadius="50%" mr="12px" sx={{ background: '#000' }} />

                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>Created at</ScholarShipCardDeadlineText>
                                {item?.data?.deadline ? (
                                    <ScholarShipCardDeadlineContent>
                                        {formatDate(item?.data?.createdAt)}
                                    </ScholarShipCardDeadlineContent>
                                ) : (
                                    <ScholarShipCardDeadlineContent>
                                        {formatDate(item?.createdAt)}
                                    </ScholarShipCardDeadlineContent>
                                )}
                            </Box>
                        </Box>
                    )}

                    {item?.scholarshipType && (
                        <Box display="flex" alignItems="center" mr="8px">
                            <Box width="5px" height="5px" borderRadius="50%" mr="12px" sx={{ background: '#000' }} />

                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>Type</ScholarShipCardDeadlineText>

                                <ScholarShipCardDeadlineContent>{item?.scholarshipType}</ScholarShipCardDeadlineContent>
                            </Box>
                        </Box>
                    )}

                    {usedTab === 'external-scholarship-admin' && (
                        <Box display="flex" alignItems="center" mr="8px">
                            <Box width="5px" height="5px" borderRadius="50%" mr="12px" sx={{ background: '#000' }} />

                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>Total</ScholarShipCardDeadlineText>

                                <ScholarShipCardDeadlineContent>{item?.totalSchools}</ScholarShipCardDeadlineContent>
                            </Box>
                        </Box>
                    )}

                    {usedTab === 'external-scholarship-admin' && (
                        <Box display="flex" alignItems="center" mr="8px">
                            <Box width="5px" height="5px" borderRadius="50%" mr="12px" sx={{ background: '#000' }} />

                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>Active</ScholarShipCardDeadlineText>

                                <ScholarShipCardDeadlineContent>
                                    {item?.isActive ? 'Yes' : 'No'}
                                </ScholarShipCardDeadlineContent>
                            </Box>
                        </Box>
                    )}

                    {showCompetition && (
                        <Box display="flex" alignItems="center">
                            <Box width="5px" height="5px" mr="12px" borderRadius="50%" sx={{ background: '#000' }} />
                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>Competition</ScholarShipCardDeadlineText>
                                <ScholarShipCardDeadlineContent>
                                    {item?.data?.competitionLevel}
                                </ScholarShipCardDeadlineContent>
                            </Box>
                        </Box>
                    )}



                    {usedTab === 'counselor-manage' && (
                        <Box display="flex" alignItems="center">
                            <Box width="5px" height="5px" mr="12px" borderRadius="50%" sx={{ background: '#000' }} />
                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>Applicants</ScholarShipCardDeadlineText>
                                <ScholarShipCardDeadlineContent>{item?.noOfApplicants}</ScholarShipCardDeadlineContent>
                            </Box>
                        </Box>
                    )}

                    {usedTab === 'counselor-organization' && item?.state && (
                        <Box display="flex" alignItems="center" mr="8px">
                            <Box width="5px" height="5px" mr="12px" borderRadius="50%" sx={{ background: '#000' }} />
                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>State</ScholarShipCardDeadlineText>
                                <ScholarShipCardDeadlineContent>{item?.state}</ScholarShipCardDeadlineContent>
                            </Box>
                        </Box>
                    )}

                    {usedTab === 'counselor-organization' && (
                        <Box display="flex" alignItems="center">
                            <Box width="5px" height="5px" mr="12px" borderRadius="50%" sx={{ background: '#000' }} />
                            <Box textAlign="left">
                                <ScholarShipCardDeadlineText>Total Scholarships</ScholarShipCardDeadlineText>
                                <ScholarShipCardDeadlineContent>{item?.totalScholarships}</ScholarShipCardDeadlineContent>
                            </Box>
                        </Box>
                    )}
                </Box>
                <Box display="flex" m="8px 0 0 0" justifyContent="space-between" alignItems="center" width="100%">
                    {(usedTab === 'saved' ||
                        usedTab === 'find' ||
                        usedTab === 'embeddedSholarship' ||
                        usedTab === 'counselor-manage' ||
                        usedTab === 'list-booster' ||
                        usedTab === 'counselor-list' ||
                        usedTab === 'multiple-scholarship-url' ||
                        usedTab === 'scholarship-admin' ||
                        usedTab === 'scholarshipInfo' ||
                        usedTab === 'landingPage'
                    ) && (
                            <ScholarShipCardAmount>{'$' + item?.amount?.toLocaleString()}</ScholarShipCardAmount>
                        )}

                    <Box sx={{ width: '100%' }}>
                        {usedTab === 'saved' ? (
                            isExpired || item?.data?.applicationStatus !== null ? null : (
                                <Box display="flex" width="100%" justifyContent="flex-end">
                                    <SecondaryButton
                                        sx={{
                                            alignSelf: 'center',
                                            height: '28px',
                                            width: 'fit-content',
                                            p: '2px 32px',
                                            fontSize: '14px',
                                            backgroundColor: COLOR_SECONDARY,
                                            '&:hover': {
                                                background: COLOR_SECONDARY,
                                            },
                                        }}
                                        onClick={() => handleScholarshipApply(item?.applyable, item?.data)}>
                                        Apply
                                    </SecondaryButton>
                                </Box>
                            )
                        ) : null}

                        {usedTab === 'find' && (
                            <Box display="flex" width="100%" justifyContent="flex-end">
                                <SecondaryButton
                                    sx={{
                                        alignSelf: 'center',
                                        height: '28px',
                                        width: 'fit-content',
                                        p: '2px 32px',
                                        fontSize: '14px',
                                        backgroundColor: COLOR_SECONDARY,
                                        '&:hover': {
                                            backgroundColor: COLOR_SECONDARY,
                                        },
                                    }}
                                    onClick={() => handleScholarshipApply(item?.applyable, item?.data)}>
                                    Apply
                                </SecondaryButton>
                            </Box>
                        )}

                        {usedTab === 'counselor-manage' && (
                            <Box display="flex" width="100%" justifyContent="flex-end">
                                <SecondaryButton
                                    sx={{
                                        backgroundColor: COLOR_ORANGE_PRIMARY,
                                        alignSelf: 'center',
                                        height: '28px',
                                        width: 'fit-content',
                                        p: '2px 32px',
                                        fontSize: '14px',

                                        '&:hover': {
                                            backgroundColor: COLOR_ORANGE_PRIMARY,
                                        },
                                    }}
                                    onClick={() => viewScholarShipCounselor && viewScholarShipCounselor(item?.id, item)}>
                                    View
                                </SecondaryButton>
                            </Box>
                        )}

                        {usedTab === 'scholarshipInfo' && (
                            <Box display="flex" width="100%" justifyContent="flex-end">
                                <SecondaryButton
                                    sx={{
                                        background: COLOR_ORANGE_PRIMARY,
                                        alignSelf: 'center',
                                        height: '28px',
                                        width: 'fit-content',
                                        p: '2px 32px',
                                        fontSize: '14px',

                                        '&:hover': {
                                            background: COLOR_ORANGE_PRIMARY,
                                        },
                                    }}
                                    onClick={() => ViewScholarshipInfo && ViewScholarshipInfo(responsedata[item?.id])}>
                                    Review
                                </SecondaryButton>
                            </Box>
                        )}

                        {usedTab === 'embeddedSholarship' && (
                            <Box display="flex" width="100%" justifyContent="flex-end">
                                <SecondaryButton
                                    sx={{
                                        background: brandingBgColor ? brandingBgColor : COLOR_ORANGE_PRIMARY,
                                        alignSelf: 'center',
                                        height: '28px',
                                        width: 'fit-content',
                                        p: '2px 32px',
                                        fontSize: '14px',
                                        '&:hover': {
                                            background: brandingBgColor ? brandingBgColor : COLOR_ORANGE_PRIMARY,
                                        },
                                    }}
                                    onClick={() =>
                                        handleViewEmbeddedScholarship && handleViewEmbeddedScholarship(item?.id)
                                    }>
                                    View
                                </SecondaryButton>
                            </Box>
                        )}
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '4px',
                                width: '100%',
                                justifyContent: 'space-between',
                            }}>
                            {usedTab === 'counselor-organization' && (
                                <Box>
                                    <SecondaryButton
                                        sx={{
                                            background: COLOR_ORANGE_PRIMARY,
                                            alignSelf: 'center',
                                            height: '28px',
                                            width: 'fit-content',
                                            p: '2px 32px',
                                            fontSize: '14px',
                                            whiteSpace: 'nowrap',

                                            '&:hover': {
                                                background: COLOR_ORANGE_PRIMARY,
                                            },
                                        }}
                                        onClick={() =>
                                            viewOrganizationScholarship && viewOrganizationScholarship(item?.id)
                                        }>
                                        View Scholarships
                                    </SecondaryButton>
                                </Box>
                            )}
                            {usedTab === 'scholarship-admin' && showRemoveBtn && (
                                <Box width="100%" display="flex" justifyContent="flex-end">
                                    <Typography
                                        sx={{
                                            fontFamily: 'Poppins',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            fontStyle: 'normal',
                                            cursor: 'pointer',
                                            width: 'fit-content',
                                            color: COLOR_ORANGE_PRIMARY,
                                            '&:hover': {
                                                color: COLOR_ORANGE_PRIMARY,
                                            },
                                        }}
                                        onClick={() => deleteAdminScholarship && deleteAdminScholarship(item?.id)}>
                                        <DeleteForeverRoundedIcon sx={{ color: COLOR_ORANGE_PRIMARY, cursor: 'pointer' }} />
                                    </Typography>
                                </Box>
                            )}

                            {usedTab === 'counselor-organization' && showRemoveBtn && (
                                <Box>
                                    <Typography
                                        sx={{
                                            fontFamily: 'poppins',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            fontStyle: 'normal',
                                            cursor: 'pointer',
                                            color: COLOR_ORANGE_PRIMARY,
                                            '&:hover': {
                                                color: 'orange',
                                            },
                                        }}
                                        onClick={() => removeOrganization && removeOrganization(item?.id)}>
                                        <DeleteForeverRoundedIcon sx={{ color: COLOR_ORANGE_PRIMARY, cursor: 'pointer' }} />
                                    </Typography>
                                </Box>
                            )}
                            {usedTab === 'counselor-organization' && showAddBtn && (
                                <Box>
                                    <Typography
                                        sx={{
                                            fontFamily: 'poppins',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            fontStyle: 'normal',
                                            cursor: 'pointer',
                                            color: COLOR_ORANGE_PRIMARY,
                                            '&:hover': {
                                                color: 'orange',
                                            },
                                        }}
                                        onClick={() => addScholarshipList && addScholarshipList(item?.id)}>
                                        <AddCircleRoundedIcon sx={{ color: COLOR_ORANGE_PRIMARY, cursor: 'pointer' }} />
                                    </Typography>
                                </Box>
                            )}
                        </Box>

                        {(usedTab === 'applied' || usedTab === 'awarded') && (
                            <Box width="100%" display="flex" flexWrap="wrap" gap="8px" justifyContent="space-between">
                                {usedTab === 'applied' && (
                                    <Box>

                                        <SecondaryButton
                                            sx={{
                                                background: item?.data?.applicationStatus === 'complete' ? COLOR_ORANGE_PRIMARY : COLOR_SECONDARY,
                                                alignSelf: 'center',
                                                height: '28px',
                                                width: 'fit-content',
                                                p: '2px 32px',
                                                fontSize: '14px',

                                                '&:hover': {
                                                    background: item?.data?.applicationStatus === 'complete' ? COLOR_ORANGE_PRIMARY : COLOR_SECONDARY,
                                                },
                                            }}
                                            onClick={() =>
                                                handleScholarshipViewResume(
                                                    item?.applyable,
                                                    item?.data?.applicationStatus,
                                                    item?.data?.url,
                                                    item?.id
                                                )
                                            }>
                                            {item?.data?.applicationStatus === 'complete' ? 'View' : "Resume"}
                                        </SecondaryButton>

                                        <ResumeText>Your Saved Progress </ResumeText>
                                    </Box>
                                )}
                                {usedTab === 'awarded' && (
                                    <Box>
                                        <SecondaryButton
                                            sx={{
                                                background: COLOR_ORANGE_PRIMARY,
                                                alignSelf: 'center',
                                                height: '28px',
                                                width: 'fit-content',
                                                p: '2px 32px',
                                                fontSize: '14px',

                                                '&:hover': {
                                                    background: COLOR_ORANGE_PRIMARY,
                                                },
                                            }}
                                            onClick={() =>
                                                viewAwardedScholarship && viewAwardedScholarship(item?.data?.url)
                                            }>
                                            View
                                        </SecondaryButton>
                                        <ResumeText>Your Submitted Application </ResumeText>
                                    </Box>
                                )}

                                {!item?.applyable && usedTab === 'applied' && (
                                    <Box display="flex" alignItems="center">
                                        <DidyouWinText>Did you win?</DidyouWinText>
                                        <Switch
                                            color="primary"
                                            checked={item?.didyouwin}
                                            onChange={() => handleToggleWin && handleToggleWin(item)}
                                            style={{
                                                color: '#386BF6',
                                            }}
                                        />
                                    </Box>
                                )}
                            </Box>
                        )}

                        {usedTab === 'counselor-list' && showRemoveBtn && (
                            <Box display="flex" width="100%" justifyContent="flex-end">
                                <Typography
                                    sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        fontStyle: 'normal',
                                        cursor: 'pointer',
                                        color: COLOR_ORANGE_PRIMARY,
                                        '&:hover': {
                                            color: 'orange',
                                        },
                                    }}
                                    onClick={() => handleRemoveScholarship && handleRemoveScholarship(item?.id)}>
                                    <DeleteForeverRoundedIcon sx={{ color: COLOR_ORANGE_PRIMARY, cursor: 'pointer' }} />
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </ScholarShipCard>
        </Link>
    );
}
